/* eslint-disable react/no-array-index-key */
import React, { Component } from "react"
import styled, { css } from "styled-components"
import PropTypes from "prop-types"
import { toPng } from "html-to-image"
import axios from "axios"

import SchoolTray from "../../../assets/images/tray_selector/School-Tray.png"
import DownloadIcon from "../../../assets/images/download_icon.png"
import UndoIcon from "../../../assets/images/tray_selector/baseline-refresh-24px.svg"
import ResizableContent from "./ResizableContent"
import UploadImageBox from "./UploadImageBox"
import { RingLoader } from "./../shared/components/Spinner"

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 800px;
  display: flex;
  justify-content: center;
`

const DesignerTray = styled.div`
  position: relative;
  height: 800px;
  width: 800px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-image: url(${({ trayImagePath }) => trayImagePath});
  background-repeat: no-repeat;
  background-size: cover; */
`

const ButtonRow = styled.div`
  position: relative;
  width: 440px;
  margin: 20px auto;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  color: #bbb;
  font-family: "Open Sans";
  text-transform: uppercase;
  font-size: 16px;
  z-index: 1;
  user-select: none;
`

const Icon = styled.img`
  position: relative;
  width: 100%;
  height: 100%;
`

const GenerateImageButton = styled.button`
  position: relative;
  width: 40px;
  height: 40px;
  display: block;
  left: 0;
  background-color: #ffffff;
  border-radius: 3px;
  box-shadow: 8px 8px 12px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: 0.15s transform ease;
  padding: 8px;
  margin-right: 8px;
  outline: none;
`

const DesignerMask = styled.div`
  align-items: center;
  border: ${({ generatingImage }) =>
    generatingImage ? "none" : "1px solid white"};
  border-radius: ${({ mask }) =>
    typeof mask.borderRadius === "number"
      ? `${mask.borderRadius}px`
      : mask.borderRadius};
  box-shadow: 8px 8px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  height: ${({ mask }) => mask.height}px;
  justify-content: center;
  position: relative;
  width: ${({ mask }) => mask.width}px;
  cursor: pointer;
  overflow: hidden;
  background-color: ${p => (p.bg ? p.bg : "transparent")};
  z-index: 2;
  ${p => (p.mask.custom ? css(p.mask.custom) : undefined)}
`

const ResizableArea = styled.div`
  position: absolute;
  align-items: center;
  border-radius: ${({ mask }) => mask.borderRadius}px;
  display: flex;
  height: ${({ mask }) => mask.height}px;
  width: ${({ mask }) => mask.width}px;
  justify-content: center;
  z-index: 3;
`

const Thumbnail = styled.img`
  position: absolute;
  width: ${({ width }) => width || 100}px;
  user-select: none;
  top: ${({ top }) => top || 0}px;
  left: ${({ left }) => left || 0}px;
  transform: translateY(${({ height }) => height / 2}px) translateY(-50%)
    rotate(${({ rotateAngle }) => rotateAngle}deg);
`

const ErrorMessage = styled.div`
  position: relative;
  width: 100%;
  text-align: center;
  color: red;
`

const CloseButton = styled.div`
  position: absolute;
  width: 16px;
  height: 16px;
  top: -20px;
  right: -20px;
  background-color: tomato;
  text-align: center;
  line-height: 14px;
  color: white;
  border-radius: 50%;
  font-weight: bold;
  cursor: pointer;
`

class Designer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      error: null,
      thumbnail: null,
      generatingImage: false,
      imageInfo: {
        width: 100,
        height: 100,
        top: 100,
        left: 100,
        rotateAngle: 0,
      },
    }

    this.defaultTray = SchoolTray

    this.defaultMask = {
      width: 600,
      height: 450,
      borderRadius: 70,
      textColor: "white",
    }

    this.trayRef = React.createRef()

    this.thumbRef = React.createRef()

    this.getTrayImagePath = trayName => `/images/${trayName}-tray.png`

    this.onImageInfoChange = newInfo =>
      this.setState(({ imageInfo }) => ({
        imageInfo: {
          ...imageInfo,
          ...newInfo,
        },
      }))

    this.addUploadedThumbnail = file => {
      const { height, width, dataURL: thumbnail } = file
      const aspect = height / width

      // so image can fit the tray if it's too big
      const newWidth = 300
      const newHeight = newWidth * aspect

      this.setState(prevState => ({
        thumbnail,
        imageInfo: {
          ...prevState.imageInfo,
          width: newWidth || 300,
          height: newHeight || 300,
        },
      }))
    }

    this.removeUploadedThumbnail = () => {
      this.setState({ thumbnail: null })
      this.resetResizableRectangle()
    }

    this.resetResizableRectangle = () =>
      this.setState({
        imageInfo: {
          width: 100,
          height: 100,
          top: 100,
          left: 100,
          rotateAngle: 0,
        },
      })

    this.dataURLtoBlob = dataUrl => {
      const arr = dataUrl.split(",")
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }

      return new Blob([u8arr], { type: mime })
    }

    this.downloadImage = () =>
      this.setState(
        {
          generatingImage: true,
        },
        async () => {
          if (this.trayRef) {
            toPng(this.trayRef.current, {
              backgroundColor: "transparent",
            }).then(dataUrl => {
              const imageBlob = this.dataURLtoBlob(dataUrl)
              const imageURL = URL.createObjectURL(imageBlob)

              const link = document.createElement("a")
              link.download = "personalized-tray.png"
              link.href = imageURL

              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link)

              this.setState({ generatingImage: false })
            })
          }
        }
      )

    this.generateImage = () =>
      this.setState(
        {
          generatingImage: true,
        },
        () => {
          if (this.trayRef) {
            toPng(this.trayRef.current, {
              backgroundColor: "transparent",
            }).then(async dataUrl => {
              const { thumbnail } = this.state
              const { url, quote_request_id, get_quote_url } = this.props

              try {
                if (thumbnail) {
                  await axios({
                    url: `${url}/tray_selector/upload`,
                    method: "POST",
                    data: {
                      quote_request_attachment: {
                        quote_request_id,
                        image: thumbnail,
                      },
                    },
                  })

                  await axios({
                    url: `${url}/tray_selector/upload`,
                    method: "POST",
                    data: {
                      quote_request_attachment: {
                        quote_request_id,
                        image: dataUrl,
                      },
                    },
                  })

                  window.location = get_quote_url
                } else {
                  window.location = get_quote_url
                }
              } catch (error) {
                this.setState({ error, generatingImage: false })
              }
            })
          }
        }
      )
  }

  render() {
    const { thumbnail, imageInfo, generatingImage, error, base64 } = this.state
    const { image_url, mask, downloadTextButton, imageDimensions } = this.props

    return (
      <div className="designer">
        {error && <ErrorMessage>{error.message}</ErrorMessage>}

        {generatingImage && <RingLoader />}

        <div
          className="designer__content"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Wrapper>
            <DesignerTray trayImagePath={image_url} ref={this.trayRef}>
              <img
                src={image_url}
                {...imageDimensions}
                style={{ position: "absolute" }}
              />

              <DesignerMask
                mask={mask}
                generatingImage={generatingImage}
                style={{ cursor: thumbnail === null ? "pointer" : "normal" }}
                ref={this.saveMaskRef}
              >
                {thumbnail === null && (
                  <UploadImageBox
                    mask={mask}
                    generatingImage={generatingImage}
                    addUploadedThumbnail={this.addUploadedThumbnail}
                    removeUploadedThumbnail={this.removeUploadedThumbnail}
                  />
                )}

                {thumbnail !== null && (
                  <Thumbnail
                    src={thumbnail}
                    ref={this.thumbRef}
                    {...imageInfo}
                  />
                )}
              </DesignerMask>

              {thumbnail !== null && !generatingImage && (
                <React.Fragment>
                  <ResizableArea mask={mask}>
                    <ResizableContent
                      {...imageInfo}
                      onChange={this.onImageInfoChange}
                      trayRef={this.trayRef}
                    >
                      <CloseButton onClick={this.removeUploadedThumbnail}>
                        x
                      </CloseButton>
                    </ResizableContent>
                  </ResizableArea>
                </React.Fragment>
              )}
            </DesignerTray>
          </Wrapper>

          <ButtonRow>
            <div
              onClick={this.removeUploadedThumbnail}
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <GenerateImageButton>
                <Icon src={UndoIcon} />
              </GenerateImageButton>{" "}
              Undo
            </div>

            <div
              onClick={this.downloadImage}
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <GenerateImageButton>
                <Icon src={DownloadIcon} />
              </GenerateImageButton>{" "}
              {downloadTextButton}
            </div>
          </ButtonRow>

          <div
            className="row"
            style={{
              display: "flex",
              justifyContent: "center",
              zIndex: "99999",
            }}
          >
            <div
              className="tray-actions"
              style={{ width: 440, cursor: "pointer" }}
            >
              <button
                className="btn-quote"
                onClick={this.generateImage}
                style={{ width: "100%" }}
              >
                Get a quote
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Designer.defaultProps = {
  downloadTextButton: "Download & Share",
  imageDimensions: {
    width: 800,
    height: 800,
  },
}

export const DesignerMaskPropTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  borderRadius: PropTypes.number,
  downloadTextButton: PropTypes.string,
}

export const DesignerPropTypes = {
  tray: PropTypes.shape({
    image: PropTypes.object,
    mask: PropTypes.shape(DesignerMaskPropTypes),
  }).isRequired,
  url: PropTypes.string.isRequired,
  image_url: PropTypes.string.isRequired,
  downloadTextButton: PropTypes.string,
  trayColor: PropTypes.string,
}

Designer.propTypes = DesignerPropTypes

export default Designer
